import React from "react";
import 'reactjs-popup/dist/index.css';
import './Links.css';
import Popup from 'reactjs-popup';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faMapLocationDot, faUtensils } from "@fortawesome/free-solid-svg-icons";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

// const menuImages = [
//     "https://previews.123rf.com/images/prettyvectors/prettyvectors2108/prettyvectors210800028/172956545-fast-food-main-menu-template-mock-for-cafe-and-restaurant-design-for-print.jpg",
//     "https://marketplace.canva.com/EAFB_Qicq9s/1/0/1236w/canva-simple-minimalist-wedding-menu-5SnBT3_eNKI.jpg"
// ]

function Links({menuImages}) {
    return(
        <div id="links">
            <a href="https://www.google.com/maps?cid=4652450288175630188" target="blank"><FontAwesomeIcon icon={faMapLocationDot} /><br></br>Map</a>
            <a href="tel:(734) 246-4240"><FontAwesomeIcon icon={faPhone} /><br></br>Call</a>
            <Popup trigger={<div className="popupMenu"><FontAwesomeIcon icon={faUtensils} /><br></br>Menu</div>} modal nested>
            {close => (
                <div className="modal">
                    <button className="close" onClick={close}>&times;</button>
                    <div className="header"> Menu </div>
                    <div className="content">
                        <Carousel className='menuReel' showIndicators={false} dynamicHeight={false} emulateTouch={true} infiniteLoop={true} selectedItem={0} showStatus={false} showThumbs={false}>
                            {menuImages.map((image, index) => <TransformWrapper key={index}><TransformComponent><img src={image} alt="" className='menuImg'/></TransformComponent></TransformWrapper>)}
                        </Carousel>
                    </div>
                </div>
            )}
            </Popup>
        </div>
    )
}

export default Links;